import React, { useEffect, useRef, useState } from 'react'
import {  useNavigate } from 'react-router-dom';
import axios from 'axios';
import language from '../../variables/language';
import { DateTime } from  "luxon";
import IconDone from '../../components/icons/IconDone';
import IconWrong from '../../components/icons/IconWrong';
import IconInwork from '../../components/icons/IconInwork';
import IconAccepted from '../../components/icons/IconAccepted';
import IconMessages from '../../components/icons/IconMessages';

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

const linkifyText = (text) => {
   if(!text) {
      return text;
   }
   return text.split(URL_PATTERN).map((part, i) =>
      URL_PATTERN.test(part) ? (
         <a key={i} href={part} target='_blank' rel='noreferrer' className='client-chat-link' onClick={(e) => e.stopPropagation()}>{part}</a>
      ) : part
   );
}

const formatMessageTime = (dateTime) => {
   if(!dateTime) {
      return '';
   }
   try{
      return DateTime.fromISO(dateTime.replace(/\[.*\]/, ""), { setZone: true }).toFormat("HH:mm");
   }catch(e){
      return '';
   }
}

export default function ConvProgressPart(props) {
   const navigate = useNavigate();
   const [messages, setMessages] = useState([]);
   const [conversations, setConversations] = useState([]);
   const [currentConvProgId, setCurrentConvProgId] = useState();
   const [messagesLoading, setMessagesLoading] = useState(false);
   const requestedConvProgId = useRef();
   const chatScrollRef = useRef(null);
   const urlConversationsProgress = '/api/conversationprogress/client';

   useEffect(()=> {
      setMessages([])
      setCurrentConvProgId();
      requestedConvProgId.current = undefined;
      getConversations();
   },[props.clientId])

   useEffect(() => {
      if(chatScrollRef.current) {
         chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
      }
   },[messages])

   const getConversations = () => {
       if(!props.clientId) {
          return;
       }
       axios.get(
         urlConversationsProgress+'?client='+ new Number(props.clientId) ,
        { withCredentials: true }
      ).then(response => {
         setConversations(response.data);
      })
      .catch(err => console.error(err));
   }

   const openMessages = (e, convProgId) => {
         e.stopPropagation();

         if (currentConvProgId === convProgId) {
            setCurrentConvProgId();
            setMessages([]);
            requestedConvProgId.current = undefined;
            return;
         }

         setCurrentConvProgId(convProgId);
         setMessages([]);
         setMessagesLoading(true);
         requestedConvProgId.current = convProgId;
         getMessages(convProgId)
               .then(response => {
                  if(requestedConvProgId.current !== convProgId) {
                     return;
                  }
                  setMessages(response.data)
               })
               .catch(err => {
                  console.log(err);
               })
               .finally(() => {
                  if(requestedConvProgId.current === convProgId) {
                     setMessagesLoading(false);
                  }
               });

   }


   const getMessages = (id) => {

    return  axios.get('/api/messages/byconvprogress/' + id, {
            withCredentials: true});
   }

   const goToMessages = (e,convId) => {
      e.stopPropagation();
      navigate("/messages/byconvprogress/"+convId);
   }

   const userInitial = (props.client && props.client.firstName) ? props.client.firstName.trim().charAt(0).toUpperCase() : 'U';

  return (
    <div className={`conv-progress-menu ${props.className}`}   >

      <div className='conv-progress-menu-selector'>
         <div className='conv-progress-header'><p className='txt-c'>{language[language.lang]['clients conversations']}
            {Array.isArray(conversations) && conversations.length > 0 ? ` (${conversations.length})` : ''}:</p></div>
         {Array.isArray(conversations) && conversations.length > 0 ? (
                  conversations.map(item => (
                     <div key={item.id}>
                        <div  onClick={(e) => openMessages(e, item.id)}
                        className={'card-selector-conv-progress txt-c' + (item.id === currentConvProgId && (messagesLoading || messages.length > 0) ? ' conv-row-active' : '')}>
                              <div className='conv-row-icon-btn' onClick={(e) => goToMessages(e, item.id)} title={language[language.lang].messages}>
                                 <IconMessages style={{width:14,height:14,margin:0,fill:'var(--lighttext-color)'}} />
                              </div>
                              <span className='conv-row-name'>{item.conversationId.name}</span>
                              <span className='conv-row-date'>{ DateTime.fromISO(item.dAdd, { setZone: true }).toFormat("dd.MM.yyyy HH:mm")}</span>
                              <span className='conv-row-status' title={item.isFinished == 1 ? language[language.lang].isFinished : language[language.lang].inProgress}>
                              {item.isFinished == 1 ? (
                                    <IconDone fillColor='icon-green' ></IconDone>
                              ) : (
                                    <IconInwork fillColor='icon-yellow' ></IconInwork>
                              ) }
                              </span>
                        </div>
                        {item.id === currentConvProgId ? (
                           <div className='client-chat-scroll' ref={chatScrollRef}>
                              {
                                messagesLoading ? (
                                   <div className='client-chat-loader'></div>
                                ) :
                                Array.isArray(messages) && messages.length > 0 ? (
                                    messages.map(m => {
                                       const isBot = m.isBot == 1;
                                       const isCorrect = !isBot && m.answerConnector && m.answerConnector.isRight && m.answerConnector.isRight.id === 1;
                                       const isWrong = !isBot && m.answerConnector && m.answerConnector.isRight && m.answerConnector.isRight.id === 2;
                                       return (
                                          <div key={m.id} className={'client-chat-row ' + (isBot ? 'client-chat-row-bot' : 'client-chat-row-user')}>
                                             {isBot ? <div className='client-chat-avatar client-chat-avatar-bot' title='Bot'>B</div> : ''}
                                             <div className={'client-chat-bubble ' + (isBot ? 'client-chat-bubble-bot' : 'client-chat-bubble-user')
                                                + (isCorrect ? ' client-chat-bubble-correct' : '') + (isWrong ? ' client-chat-bubble-wrong' : '')}>
                                                <p className='client-chat-bubble-text'>{linkifyText(m.text)}</p>
                                                <div className='client-chat-bubble-footer'>
                                                   {isCorrect ? <IconAccepted fillColor='icon-green'></IconAccepted> : ''}
                                                   {isWrong ? <IconWrong fillColor='icon-red'></IconWrong> : ''}
                                                   <span className='client-chat-bubble-time'>{formatMessageTime(m.dateTime)}</span>
                                                </div>
                                             </div>
                                             {!isBot ? <div className='client-chat-avatar client-chat-avatar-user' title={props.client && props.client.firstName}>{userInitial}</div> : ''}
                                          </div>
                                       );
                                    })
                                 ) : (
                                    <div className='client-conv-empty'>{language[language.lang]['empty list']}</div>
                                 )
                              }
                           </div>
                        ) : ''}

                     </div>
                  ))
               ) : (
                  <div className='client-conv-empty empty-list'>{language[language.lang]['empty list']}</div>
            )}

      </div>



    </div>
  )
}
